
<template>
  <div></div>
</template>

<style scoped>

</style>
<script>
import {getImei, readCommonParam} from "@/util/session-storage-utils";
import {navigateToIndex, navigateToMapStreetview} from "@/util/jsinterfaces-util";
import {lastLocation} from "@/api/location";
export default {
  name: "CallIndex",
  created(){
    readCommonParam(this)
    // document.title = this.$t("");
  },
  mounted(){
    document.addEventListener('visibilitychange', this.getHiddenStatus, true);
    lastLocation(getImei()).then(resp => {
      let location = resp.data
      if(location.lng && location.lat){
        navigateToMapStreetview(getImei(),location.lng,location.lat)
      }
    })
  },
  data(){
    return {
      hidden:false
    }
  },
  methods:{
    getHiddenStatus() {
      const isHidden = document.hidden;
      if (isHidden) {
        this.hidden = true
      } else {
        if(this.hidden){
          navigateToIndex(getImei())
        }
      }
    }
  }
}
</script>
